module.exports = __webpack_public_path__ + "static/media/Tombeau-cover.5be1fc76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Tombeau/Tombeau-cover.jpg
// module id = 111
// module chunks = 51